import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer-container">
        <div className="center-text">
          Show Your Appreciation! Recognize Your Peers Today!
        </div>

        <div className="tooltip-container">
          <span className="privacy-text">Privacy Statement</span>
          <div className="tooltip-box">
            Disclaimer – This Reward and Recognition webpage is intended solely for the internal use of employees of Aptean. The content, including employee achievements and recognition details, is shared to promote a positive work environment and celebrate accomplishments within the organization. While every effort is made to ensure the accuracy of the information provided, Aptean does not guarantee its completeness or accuracy and reserves the right to modify or remove content without prior notice. The information on this webpage is confidential and proprietary to Aptean. Unauthorized access, sharing, or dissemination of the content is strictly prohibited. Employees are expected to respect the privacy of their colleagues and use the information responsibly in accordance with company policies. Any breach of confidentiality may result in disciplinary action and could also have legal consequences.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
